import { useQuery } from '@tanstack/react-query';
import { GetQuotesOptions } from '@acp/shared';
import { getImmediateActionQuotes, getQuoteById, getQuotes } from '../service';

function usePropertyQuotes(propertyId: number, options: GetQuotesOptions = {}) {
    const query = useQuery({
        queryKey: ['property', propertyId, 'quotes', options],
        queryFn: () => getQuotes({
            propertyId,
            ...options,
        }),
    });

    return query;
}

function useQuote(quoteId: number) {
    const query = useQuery({
        queryKey: ['quote', quoteId],
        queryFn: () => getQuoteById(quoteId),
    });

    return query;
}

function useImmediateResponseQuotes({
    propertyManagerId,
}: {
    propertyManagerId?: string;
}) {
    const query = useQuery({
        refetchOnWindowFocus: true,
        queryKey: ['dashboard', 'tab', 'immediate-action-quotes', { propertyManagerId }],
        queryFn: () => getImmediateActionQuotes({ propertyManagerId }),
    });

    return query;
}

export { usePropertyQuotes, useQuote, useImmediateResponseQuotes };
